import React from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

import {BackToTopButton} from './BackToTopButton'
import {PaginationFooter} from './PaginationFooter'
import useDetectBottomOfPage from './useDetectBottomOfPage'
import usePagination, {PaginationState} from './usePagination'

const PaginationFooterWrapper = styled.div`
  text-align: center;
  margin: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s800}
    ${cssTheme.layout.spacing.s600} ${cssTheme.layout.spacing.s800};
  ${linariaMq.desktopXs} {
    margin: ${cssTheme.layout.spacing.s600} ${cssTheme.layout.spacing.s800}
      ${cssTheme.layout.spacing.s700} ${cssTheme.layout.spacing.s800};
  }
`

export const Pagination: React.FC = ({children}) => {
  const {
    currentPageNumber,
    paginationState,
    onScrollToTop,
    onLoadMore,
    onPrefetchResults
  } = usePagination()

  useDetectBottomOfPage({
    distance: 1500,
    onDetected: onPrefetchResults
  })

  return (
    <>
      {children}

      <PaginationFooterWrapper>
        <PaginationFooter
          paginationState={paginationState}
          onLoadMore={onLoadMore}
        />
      </PaginationFooterWrapper>

      {paginationState !== PaginationState.Disabled && (
        <BackToTopButton
          enabled={currentPageNumber > 1}
          onClick={onScrollToTop}
        />
      )}
    </>
  )
}
